import { FC } from 'react';
import { AutoFillIcon, ThumbsUpIcon, WandIcon } from 'assets/icons';

interface AutoFillFeedbackBannerProps {
  autoFilledFieldsCount?: number;
  onStartNewAutoFill?: () => void;
  onFeedbackLike?: () => void;
  onFeedbackDislike?: () => void;
  subText?: string;
  isLoading?: boolean;
}

const FEEDBACK_QUESTION = 'How did we do?';
const FEEDBACK_SUBTEXT = 'Your feedback helps us improve.';
const DEFAULT_SUB_TEXT = 'Please review the highlighted items before creating the invoice.';

const AutoFillFeedbackBanner: FC<AutoFillFeedbackBannerProps> = ({
  autoFilledFieldsCount = 0,
  onStartNewAutoFill,
  onFeedbackLike,
  onFeedbackDislike,
  isLoading = false,
  subText = DEFAULT_SUB_TEXT
}) => {
  return (
    <div className="mb-6 rounded-md border border-borderGray bg-[#F5FFEE] p-3" role="banner">
      <div className="flex flex-row flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 flex-1 flex-row items-start gap-3">
          <AutoFillIcon className="path path-fill-current mt-0.5 h-5 w-5 shrink-0 text-headingGray" aria-hidden />
          <div className="min-w-0 flex-1">
            <p className="text-base font-bold text-headingGray">
              AI filled <span className="font-semibold">{autoFilledFieldsCount}</span>{' '}
              {autoFilledFieldsCount > 1 ? 'fields' : 'field'}
            </p>
            <p className="mt-0.5 text-sbase text-headingGray">{subText}</p>
          </div>
        </div>
        <button
          type="button"
          onClick={onStartNewAutoFill}
          className="flex h-9 w-[182px] shrink-0 flex-row items-center gap-1.5 rounded border
           border-secondary px-3 py-1.5 text-sbase font-semibold text-secondary hover:opacity-90"
          tabIndex={0}
          disabled={isLoading}
          aria-label="Start new auto-fill">
          <WandIcon />
          Start new auto-fill
        </button>
      </div>

      <div className="mt-3 border-t border-[#4F715633] pt-3">
        <div className="flex flex-row flex-wrap items-center justify-between gap-3">
          <div className="flex gap-2">
            <p className="text-px13 font-bold text-primaryText">{FEEDBACK_QUESTION}</p>
            <p className="text-px13 font-medium text-accentText">{FEEDBACK_SUBTEXT}</p>
          </div>
          <div className="flex flex-row items-center gap-2">
            <button
              type="button"
              onClick={onFeedbackLike}
              className="rounded p-1.5 text-gray-500 transition-colors hover:bg-green-100 hover:text-gray-700"
              tabIndex={0}
              disabled={isLoading}
              aria-label="Feedback: good">
              <ThumbsUpIcon className="path path-fill-current h-5 w-5 text-primaryText" aria-hidden />
            </button>
            <button
              type="button"
              onClick={onFeedbackDislike}
              className="rounded p-1.5 text-gray-500 transition-colors hover:bg-green-100 hover:text-gray-700"
              tabIndex={0}
              disabled={isLoading}
              aria-label="Feedback: could be better">
              <ThumbsUpIcon className="path path-fill-current h-5 w-5 rotate-180 text-primaryText" aria-hidden />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoFillFeedbackBanner;
